export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";